var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"animated-number"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('span',{key:_vm.value,staticClass:"animated-number__value"},[_vm._v(_vm._s(_vm.value)),_c('span',{domProps:{"innerHTML":_vm._s(_vm.symbol)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43d7163a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/animated-number/animated-number.vue
// module id = yoSF
// module chunks = 65